// import React from 'react';

import { Flex } from 'rebass';
import { SwitchOptionStyled, SwitchStyled } from '@nike/nike-design-system-components';
import React from 'react';
import ColumnFilterSort from '../../../components/tableClientSide/ColumnFilterSort';

export const getAccountAddressesColumns = ({ toggleAddress }) => {
  return [
    {
      // eslint-disable-next-line react/prop-types
      Header: ({ column }) => <ColumnFilterSort header='Type' column={column} align='right' />,
      accessor: 'type'
    },
    {
      // eslint-disable-next-line react/prop-types
      Header: ({ column }) => <ColumnFilterSort header='Sold To' column={column} align='right' />,
      accessor: 'soldTo'
    },
    {
      // eslint-disable-next-line react/prop-types
      Header: ({ column }) => <ColumnFilterSort header='Ship To' column={column} align='left' />,
      accessor: 'shipTo'
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Shipping Address' tableInstance={tableInstance} />,
      accessor: 'address',
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => (
        <div>
          {/* eslint-disable react/prop-types */}
          <div>{row.original.address.name}</div>
          <div>{row.original.address.attention}</div>
          <div>{row.original.address.careOf}</div>
          <div>{row.original.address.addressLine1}</div>
          <div>{row.original.address.addressLine2}</div>
          <div>{row.original.address.addressLine3}</div>
          <div>{`${row.original.address.city}, ${row.original.address.state} ${row.original.address.zipCode}`}</div>
          <div>{`${row.original.address.country} ${row.original.address?.phoneNumber || ''}`}</div>
        </div>
      )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Avail on Gameday' tableInstance={tableInstance} />,
      accessor: 'isEnabled',
      width: 100,
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) =>
        // eslint-disable-next-line react/prop-types
        row.original.isEnabled !== null && (
          <Flex justifyContent='center' width='100%'>
            <SwitchStyled
              // eslint-disable-next-line react/prop-types
              selectedValue={row.original.isEnabled ? 'enable' : 'disable'}
              name='contractEnabledToggle'
              onClick={(e, value) =>
                toggleAddress({
                  toggle: value,
                  addressNumber: row.original?.address?.id, // eslint-disable-line react/prop-types
                  soldTo: row.original?.soldTo
                })
              }
            >
              <SwitchOptionStyled id='switch-address-off' label='NO' value='disable' />
              <SwitchOptionStyled id='switch-address-on' label='YES' value='enable' />
            </SwitchStyled>
          </Flex>
        )
    }
  ];
};
